// extracted by mini-css-extract-plugin
export var compactFilters = "_dt-4";
export var detailImage = "_dt-1";
export var dropdownContainer = "_dt-2";
export var imageContainer = "_dt-0";
export var selectedCard = "_dt-3";